import { render, staticRenderFns } from "./GooglePreviewBusiness.vue?vue&type=template&id=34b381d8&scoped=true&"
import script from "./GooglePreviewBusiness.vue?vue&type=script&lang=ts&"
export * from "./GooglePreviewBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./GooglePreviewBusiness.vue?vue&type=style&index=0&id=34b381d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b381d8",
  null
  
)

export default component.exports